/**
 * @generated SignedSource<<fc73f51bfd4dbd6f0cd702001ee00106>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteOrganizationInviteByIdInput = {
  clientMutationId?: string | null;
  id: string;
};
export type useRemoveInviteMutation$variables = {
  input: DeleteOrganizationInviteByIdInput;
};
export type useRemoveInviteMutation$data = {
  readonly deleteOrganizationInviteById: {
    readonly deletedOrganizationInviteId: string | null;
  } | null;
};
export type useRemoveInviteMutation = {
  variables: useRemoveInviteMutation$variables;
  response: useRemoveInviteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteOrganizationInvitePayload",
    "kind": "LinkedField",
    "name": "deleteOrganizationInviteById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedOrganizationInviteId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveInviteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRemoveInviteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "05ce071fcddd1d2859177ffd1cbc54d0",
    "id": null,
    "metadata": {},
    "name": "useRemoveInviteMutation",
    "operationKind": "mutation",
    "text": "mutation useRemoveInviteMutation(\n  $input: DeleteOrganizationInviteByIdInput!\n) {\n  deleteOrganizationInviteById(input: $input) {\n    deletedOrganizationInviteId\n  }\n}\n"
  }
};
})();

(node as any).hash = "b19ece4542739044f38d593b894e9115";

export default node;
